import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Triangle where side b = 2 * side a (internal dependency via expression).
 */
export const INTERNAL_DEPENDENCY_PRESET: GeometryPadWidgetConfig = {
  id: 'internal-dependency',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { a: 4, b: 8, gamma: 45 },
        names: { a: 'a', b: '2a' },
      },
    },
  },
  display: {
    geometry: {
      label: { coloring: true, lengthUnit: 'cm' },
    },
  },
};
